module.exports = __webpack_public_path__ + "img/tozie.fdcbd06.svg";